//LL: 07.08.23: copy of Charts/components/ChartCustomStylesField

import ParameterFieldBase, { IParameterFieldBaseOptions } from '../../../../_common/platform/ts/ParameterFieldBase';

declare var require: any;

import EditComponent from './CalendarMarkersField';

export class CalendarMarkersField extends ParameterFieldBase<IParameterFieldBaseOptions> {
    public static defaultValidators = [];

    public static EditComponent = EditComponent;

    public static getDefaultValue() {
        return [];
    }

    constructor(glob, title: string, validators?: any, defaultVal?: any, options?) {
        if (defaultVal == null) {
            defaultVal = CalendarMarkersField.getDefaultValue();
        }

        super(glob, title, CalendarMarkersField.defaultValidators, validators, defaultVal, options);
    }
}

